



























import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { VFields } from '@/models/v-fields';
import { CustomerDetail } from '@/models/accounting/customerinfo';
import { Base } from '@/components/common/base';
import { Utils } from '@/helper/utils';
import { customerService } from '@/shared';

@Component({
  props: ['methodName', 'progress'],
  computed: {
    methodtoCall: {
      get() {
        return this.$props.methodName;
      },
    },
  },
})
export default class CustomerDetailsPage extends Base {
  public updateCustomer: any = {
    phonePrefix: '1',
    businessPhonePrefix: '1',
    otherPhonePrefix: '1',
    cellPhonePrefix: '1',
  };
  public flags: any = {
    loading: false,
    updating: false,
    showStartDatePicker: false,
  };
  public form: any = {};
  public customerFields: Array<VFields<any>> = [];
  public constants: any = {
    searchParameter: '',
    searchString: '',
    lastName: '',
    firstName: '',
    customerNumber: '',
    roNumber: '',
    email: '',
    phone: '',
  };
  public isCustomerUpdateLoading: boolean = false;

  public beforeDestroy() {
    const buttons = [];
    this.$emit('updateToolBar', buttons);
  }
  public callMethod(methodName): void {
    if (methodName === 'backToList') {
      this.backToList();
    }
    if (methodName !== '') {
      this.$emit('resetMethodName', methodName);
    }
  }

  public updateToolBar(): void {
    const buttons: any = [];
    buttons.push({
      id: '0',
      type: 'button',
      title: this.$parent.$t('customerDetails.btnBackToListTitle') as string,
      disabled: false,
      visible: true,
      class: 'btn',
      label: this.$parent.$t('customerDetails.btnBackToList') as string,
      click: 'backToList',
      icon: 'fas fa-arrow-left',
      requestProgress: true,
    });
    this.$emit('updateToolBar', buttons);
  }
  public mounted() {
    // activating tab
    this.$root.$emit('sidebar.layout.vue', 'customerSearch');

    this.updateToolBar();
    this.$watch('methodtoCall', (newVal, oldVal) => {
      if (newVal) {
        this.callMethod(newVal);
      }
    });

    this.setFields();
    if (this.$route.query.searchParameter) {
      this.constants.searchParameter = this.$route.query.searchParameter;
    }
    if (this.$route.query.searchString) {
      this.constants.searchString = this.$route.query.searchString;
    }
    if (this.$route.query.lastName) {
      this.constants.lastName = this.$route.query.lastName;
    }
    if (this.$route.query.firstName) {
      this.constants.firstName = this.$route.query.firstName;
    }
    if (this.$route.query.email) {
      this.constants.email = this.$route.query.email;
    }
    if (this.$route.query.phone) {
      this.constants.phone = this.$route.query.phone;
    }

    this.constants.customerNumber = this.$route.params.customerNumber;
    if (this.constants.customerNumber) {
      this.getCustomerDetails();
    }
    this.flags.updating = false;
  }

  public setFields(): void {
    this.customerFields = [
      {
        key: 'birthDate',
        type: 'v-alynk-datepicker',
        required: false,
        templateOptions: {
          counter: 50,
          label: this.$parent.$t('customerDetails.birthDate') as string,
          validations: '',
          required: true,
          disabled: false,
          time: true,
        },
      },
      {
        key: 'typeCode',
        type: 'v-alynk-text-field',
        required: true,
        templateOptions: {
          counter: 1,
          label: this.$parent.$t('customerDetails.customerType') as string,
          validations: 'required',
          required: true,
          disabled: false,
          hint: this.$parent.$t('customerDetails.customerTypeHint') as string,
          events: {
            onChange: (val) => {
              const va = val;
              if (va === 'I' || val === 'C') {
                if (va === 'I') {
                  this.updateCustomer.firstName.required = true;
                } else {
                  this.updateCustomer.firstName.required = false;
                }
              } else {
                this.updateCustomer.typeCode = null;
              }
            },
          },
        },
      },
      {
        key: 'firstName',
        type: 'v-alynk-text-field',
        required: false,
        templateOptions: {
          counter: 15,
          disabled: false,
          label: this.$parent.$t('customerDetails.firstName') as string,
          validations: 'required',
          required: false,
        },
      },
      {
        key: 'lastName',
        type: 'v-alynk-text-field',
        required: true,
        templateOptions: {
          counter: 50,
          disabled: false,
          label: this.$parent.$t('customerDetails.lastName') as string,
          required: true,
          validations: 'required',
        },
      },
      {
        key: 'middleName',
        type: 'v-alynk-text-field',
        required: false,
        templateOptions: {
          counter: 15,
          disabled: false,
          label: this.$parent.$t('customerDetails.middleName') as string,
          validations: '',
        },
      },
      {
        key: 'salitation',
        type: 'v-alynk-text-field',
        required: false,
        templateOptions: {
          counter: 10,
          disabled: false,
          label: this.$parent.$t('customerDetails.salutation') as string,
          validations: '',
        },
      },
      {
        key: 'address1',
        type: 'v-alynk-text-field',
        required: false,
        templateOptions: {
          counter: 45,
          disabled: false,
          label: this.$parent.$t('customerDetails.address1') as string,
          validations: '',
        },
      },
      {
        key: 'address2',
        type: 'v-alynk-text-field',
        required: false,
        templateOptions: {
          counter: 45,
          disabled: false,
          label: this.$parent.$t('customerDetails.address2') as string,
          validations: '',
        },
      },
      {
        key: 'address3',
        type: 'v-alynk-text-field',
        required: false,
        templateOptions: {
          counter: 45,
          disabled: false,
          label: this.$parent.$t('customerDetails.address3') as string,
          validations: '',
        },
      },
      {
        key: 'city',
        type: 'v-alynk-text-field',
        required: false,
        templateOptions: {
          counter: 20,
          disabled: false,
          label: this.$parent.$t('customerDetails.city') as string,
          validations: '',
        },
      },
      {
        key: 'county',
        type: 'v-alynk-text-field',
        required: false,
        templateOptions: {
          counter: 18,
          disabled: false,
          label: this.$parent.$t('customerDetails.country') as string,
          validations: '',
        },
      },
      {
        key: 'stateCode',
        type: 'v-alynk-text-field',
        required: false,
        templateOptions: {
          disabled: false,
          counter: 2,
          label: this.$parent.$t('customerDetails.stateCode') as string,
          validations: '',
        },
      },
      {
        key: 'zipCode',
        type: 'v-alynk-text-field',
        required: false,
        templateOptions: {
          counter: 9,
          type: 'number',
          disabled: false,
          label: this.$parent.$t('customerDetails.zipCode') as string,
          validations: '',
        },
      },
      {
        key: 'phonePrefix',
        type: 'v-alynk-phone-field',
        required: false,
        templateOptions: {
          counter: 1,
          label: this.$parent.$t('customerDetails.prefix') as string,
          validations: 'required',
          required: false,
          disabled: true,
          elementClass: 'flex xs12 sm12 md6 lg6 pr-2',
          elementStyle: 'float:left;',
        },
      },
      {
        key: 'phoneNumber',
        required: false,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          label: this.$parent.$t('customerDetails.phoneNumber') as string,
          validations: 'required|min:10',
          mask: this.phoneMask,
          events: {
            onChange: (val) => {
              const va = val;
              if (va.length === 10) {
                return;
              } else {
                this.updateCustomer.phoneNumber = null;
              }
            },
          },
        },
      },
      {
        key: 'businessPhonePrefix',
        type: 'v-alynk-phone-field',
        required: false,
        templateOptions: {
          counter: 1,
          label: this.$parent.$t('customerDetails.prefix') as string,
          validations: 'required',
          required: false,
          disabled: true,
          elementClass: 'flex xs12 sm12 md6 lg6 pr-2',
          elementStyle: 'float:left;',
        },
      },
      {
        key: 'businessPhone',
        required: false,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          label: this.$parent.$t('customerDetails.businessPhone') as string,
          validations: 'required|min:10',
          mask: this.phoneMask,
          events: {
            onChange: (val) => {
              const va = val;
              if (va.length === 10) {
                return;
              } else {
                this.updateCustomer.businessPhone = null;
              }
            },
          },
        },
      },
      {
        key: 'businessExt',
        type: 'v-alynk-text-field',
        required: false,
        templateOptions: {
          counter: 4,
          label: this.$parent.$t(
            'customerDetails.businessPhoneExtension'
          ) as string,
          disabled: false,
          type: 'number',
          validations: '',
        },
      },
      {
        key: 'faxNumber',
        type: 'v-alynk-text-field',
        required: false,
        templateOptions: {
          disabled: false,
          label: this.$parent.$t('customerDetails.faxNumber') as string,
          validations: '',
          type: 'number',
          counter: 10,
        },
      },
      {
        key: 'preferredContact',
        type: 'v-alynk-text-field',
        required: false,
        templateOptions: {
          hint: this.$parent.$t(
            'customerDetails.preferredContactHint'
          ) as string,
          counter: 1,
          disabled: false,
          label: this.$parent.$t('customerDetails.preferredContact') as string,
          validations: '',
          events: {
            onChange: (val) => {
              const va = val;
              if (
                va === 'P' ||
                val === 'L' ||
                val === 'M' ||
                val === 'E' ||
                val === 'N'
              ) {
                return;
              } else {
                this.updateCustomer.preferredContact = null;
              }
            },
          },
        },
      },
      {
        key: 'mailCode',
        type: 'v-alynk-text-field',
        required: false,
        templateOptions: {
          hint: this.$parent.$t('customerDetails.mailCodeHint') as string,
          counter: 1,
          disabled: false,
          label: this.$parent.$t('customerDetails.mailCode') as string,
          validations: '',
          events: {
            onChange: (val) => {
              const va = val;
              if (va === 'Y' || val === 'N') {
                return;
              } else {
                this.updateCustomer.mailCode = null;
              }
            },
          },
        },
      },
      {
        key: 'customerType',
        type: 'v-alynk-text-field',
        required: false,
        templateOptions: {
          hint: this.$parent.$t(
            'customerDetails.customerTypeRetailHint'
          ) as string,
          disabled: false,
          counter: 1,
          label: this.$parent.$t(
            'customerDetails.customerTypeRetail'
          ) as string,
          validations: '',
          events: {
            onChange: (val) => {
              const va = val;
              if (va === 'R' || val === 'W') {
                return;
              } else {
                this.updateCustomer.customerType = null;
              }
            },
          },
        },
      },
      {
        key: 'preferredPhone',
        type: 'v-alynk-text-field',
        required: false,
        templateOptions: {
          hint: this.$parent.$t('customerDetails.preferredPhoneHint') as string,
          counter: 1,
          disabled: false,
          validations: '',
          label: this.$parent.$t('customerDetails.preferredPhone') as string,
          events: {
            onChange: (val) => {
              const va = val;
              if (va === 'C' || val === 'H' || val === 'B' || val === 'P') {
                return;
              } else {
                this.updateCustomer.preferredPhone = null;
              }
            },
          },
        },
      },
      {
        key: 'cellPhonePrefix',
        type: 'v-alynk-phone-field',
        required: false,
        templateOptions: {
          counter: 1,
          label: this.$parent.$t('customerDetails.prefix') as string,
          validations: 'required',
          required: false,
          disabled: true,
          elementClass: 'flex xs12 sm12 md6 lg6 pr-2',
          elementStyle: 'float:left;',
        },
      },

      {
        key: 'cellPhone',
        type: 'v-alynk-text-field',
        required: false,
        templateOptions: {
          disabled: false,
          label: this.$parent.$t('customerDetails.cellPhone') as string,
          validations: 'required|min:10',
          mask: this.phoneMask,
          events: {
            onChange: (val) => {
              const va = val;
              if (va.length === 10) {
                return;
              } else {
                this.updateCustomer.cellphone = null;
              }
            },
          },
        },
      },
      {
        key: 'pagePhone',
        type: 'v-alynk-text-field',
        required: false,
        templateOptions: {
          counter: 10,
          disabled: false,
          type: 'number',
          label: this.$parent.$t('customerDetails.pagePhone') as string,
          validations: '',
        },
      },
      {
        key: 'otherPhonePrefix',
        type: 'v-alynk-phone-field',
        required: false,
        templateOptions: {
          counter: 1,
          label: this.$parent.$t('customerDetails.prefix') as string,
          validations: 'required',
          required: false,
          disabled: true,
          elementClass: 'flex xs12 sm12 md6 lg6 pr-2',
          elementStyle: 'float:left;',
        },
      },
      {
        key: 'otherPhone',
        type: 'v-alynk-text-field',
        required: false,
        templateOptions: {
          disabled: false,
          label: this.$parent.$t('customerDetails.otherPhone') as string,
          validations: 'required|min:10',
          mask: this.phoneMask,
          events: {
            onChange: (val) => {
              const va = val;
              if (va.length === 10) {
                return;
              } else {
                this.updateCustomer.otherPhone = null;
              }
            },
          },
        },
      },
      {
        key: 'otherPhoneDesc',
        type: 'v-alynk-text-field',
        required: false,
        templateOptions: {
          counter: 15,
          disabled: false,
          label: this.$parent.$t('customerDetails.otherPhoneDesc') as string,
          validations: '',
        },
      },

      {
        key: 'email1',
        type: 'v-alynk-text-field',
        required: false,
        validators: {
          email: (field, model, next) => {
            next(Utils.EmailRegex.test(model[field.key]));
          },
        },
        templateOptions: {
          counter: 45,
          disabled: false,
          label: this.$parent.$t('customerDetails.email1') as string,
          type: 'email',
          validations: 'email',
        },
      },
      {
        key: 'email2',
        type: 'v-alynk-text-field',
        required: false,
        validators: {
          email: (field, model, next) => {
            next(Utils.EmailRegex.test(model[field.key]));
          },
        },
        templateOptions: {
          counter: 45,
          disabled: false,
          label: this.$parent.$t('customerDetails.email2') as string,
          type: 'email',
          validations: 'email',
        },
      },
      {
        key: 'businessPhoneExtension',
        type: 'v-alynk-text-field',
        required: false,
        templateOptions: {
          counter: 4,
          label: this.$parent.$t(
            'customerDetails.businessPhoneExtension'
          ) as string,
          disabled: false,
          validations: '',
        },
      },
      {
        key: 'companyNumber',
        type: 'v-alynk-text-field',
        required: true,
        templateOptions: {
          counter: 3,
          label: this.$parent.$t('customerDetails.companyNumber') as string,
          validations: 'required',
          required: true,
          disabled: false,
        },
      },
      {
        key: 'customerNumber',
        type: 'v-alynk-text-field',
        required: true,
        templateOptions: {
          counter: 9,
          label: this.$parent.$t('customerDetails.customerNumber') as string,
          validations: 'required',
          type: 'number',
          required: true,
          disabled: false,
        },
      },

      {
        key: 'gender',
        type: 'v-alynk-text-field',
        required: false,
        templateOptions: {
          hint: this.$parent.$t('customerDetails.genderHint') as string,
          counter: 1,
          label: this.$parent.$t('customerDetails.gender') as string,
          disabled: false,
          validations: '',
          events: {
            onChange: (val) => {
              const va = val;
              if (va === 'M' || val === 'F' || val === 'N' || val === 'O') {
                return;
              } else {
                this.updateCustomer.gender = null;
              }
            },
          },
        },
      },
      {
        key: 'internationalBusinessPhone',
        type: 'v-alynk-text-field',
        required: false,
        templateOptions: {
          counter: 15,
          validations: '',
          label: this.$parent.$t(
            'customerDetails.internationalBusinessPhone'
          ) as string,
          disabled: false,
          type: 'number',
        },
      },
      {
        key: 'internationalCellPhone',
        type: 'v-alynk-text-field',
        required: false,
        templateOptions: {
          counter: 15,
          label: this.$parent.$t(
            'customerDetails.internationalCellPhone'
          ) as string,
          validations: '',
          disabled: false,
          type: 'number',
        },
      },
      {
        key: 'internationalFaxNumber',
        type: 'v-alynk-text-field',
        required: false,
        templateOptions: {
          counter: 15,
          label: this.$parent.$t(
            'customerDetails.internationalFaxNumber'
          ) as string,
          validations: '',
          type: 'number',
          disabled: false,
        },
      },
      {
        key: 'internationalHomePhone',
        type: 'v-alynk-text-field',
        required: false,
        templateOptions: {
          counter: 15,
          label: this.$parent.$t(
            'customerDetails.internationalHomePhone'
          ) as string,
          validations: '',
          disabled: false,
        },
      },
      {
        key: 'internationalOtherPhone',
        type: 'v-alynk-text-field',
        required: false,
        templateOptions: {
          counter: 15,
          type: 'number',
          label: this.$parent.$t(
            'customerDetails.internationalOtherPhone'
          ) as string,
          validations: '',
          disabled: false,
        },
      },
      {
        key: 'taxExmptNumber',
        type: 'v-alynk-text-field',
        required: false,
        templateOptions: {
          counter: 20,
          label: this.$parent.$t('customerDetails.taxExmptNumber') as string,
          validations: '',
          disabled: false,
        },
      },
      {
        key: 'dealerNumber',
        type: 'v-alynk-text-field',
        required: false,
        templateOptions: {
          counter: 6,
          label: this.$parent.$t('customerDetails.dealerNumber') as string,
          validations: '',
          disabled: false,
        },
      },
      {
        key: 'serverName',
        type: 'v-alynk-text-field',
        required: true,
        templateOptions: {
          counter: 50,
          label: this.$parent.$t('customerDetails.serverName') as string,
          validations: 'required',
          required: true,
          disabled: false,
        },
      },
      {
        key: 'language',
        type: 'v-alynk-text-field',
        required: false,
        templateOptions: {
          counter: 3,
          label: this.$parent.$t('customerDetails.language') as string,

          validations: '',
          disabled: false,
        },
      },
      {
        key: 'driversLicense',
        type: 'v-alynk-text-field',
        required: false,
        templateOptions: {
          counter: 15,
          label: this.$parent.$t('customerDetails.driversLicense') as string,
          disabled: false,
          validations: '',
        },
      },
      {
        key: 'contact',
        type: 'v-alynk-text-field',
        required: false,
        templateOptions: {
          hint: this.$parent.$t('customerDetails.contactHint') as string,
          counter: 1,
          label: this.$parent.$t('customerDetails.contact') as string,
          validations: '',
          disabled: false,
          events: {
            onChange: (val) => {
              const va = val;
              if (va === 'Y' || val === 'N') {
                return;
              } else {
                this.updateCustomer.contact = null;
              }
            },
          },
        },
      },

      {
        key: 'assignedSalesperson',
        type: 'v-alynk-text-field',
        required: false,
        templateOptions: {
          counter: 3,
          label: this.$parent.$t(
            'customerDetails.assignedSalesPerson'
          ) as string,
          disabled: false,
          validations: '',
        },
      },
      {
        key: 'externalCrossReferenceKey',
        type: 'v-alynk-text-field',
        required: false,
        templateOptions: {
          counter: 9,
          type: 'number',
          label: this.$parent.$t(
            'customerDetails.externalCrossReferenceKey'
          ) as string,
          validations: '',
          disabled: false,
        },
      },
      {
        key: 'customerPreferredName',
        type: 'v-alynk-text-field',
        required: false,
        templateOptions: {
          counter: 15,
          label: this.$parent.$t(
            'customerDetails.customerPreferredName'
          ) as string,
          validations: '',
          disabled: false,
        },
      },
      {
        key: 'internationalPagerPhone',
        type: 'v-alynk-text-field',
        required: false,
        templateOptions: {
          counter: 15,
          label: this.$parent.$t(
            'customerDetails.internationalPagerPhone'
          ) as string,
          disabled: false,
          type: 'number',
          validations: '',
        },
      },
      {
        key: 'preferredLanguage',
        type: 'v-alynk-text-field',
        required: false,
        templateOptions: {
          counter: 3,
          label: this.$parent.$t('customerDetails.preferredLanguage') as string,
          hint:
            // tslint:disable-next-line:max-line-length
            this.$parent.$t('customerDetails.preferredLanguageHint') as string,
          disabled: false,
          validations: '',
          events: {
            onChange: (val) => {
              const va = val;
              if (
                va === 'ENU' ||
                va === 'CAN' ||
                va === 'FRE' ||
                va === 'FRC'
              ) {
                return;
              } else {
                this.updateCustomer.preferredLanguage = null;
              }
            },
          },
        },
      },
      {
        key: 'internationalZipCode',
        type: 'v-alynk-text-field',
        required: false,
        templateOptions: {
          counter: 9,
          label: this.$parent.$t(
            'customerDetails.internationalZipCode'
          ) as string,
          required: false,
          disabled: false,
          validations: '',
        },
      },
      {
        key: 'allowContactByPostal',
        type: 'v-alynk-switch',
        required: false,
        templateOptions: {
          label: this.$parent.$t(
            'customerDetails.allowContactByPostal'
          ) as string,
          validations: '',
          required: true,
          disabled: false,
          display: true,
        },
      },

      {
        key: 'allowContactByPhone',
        type: 'v-alynk-switch',
        required: false,
        templateOptions: {
          label: this.$parent.$t(
            'customerDetails.allowContactByPhone'
          ) as string,
          validations: '',
          required: true,
          disabled: false,
          display: true,
        },
      },
      {
        key: 'allowContactByEmail',
        type: 'v-alynk-switch',
        required: false,
        templateOptions: {
          label: this.$parent.$t(
            'customerDetails.allowContactByEmail'
          ) as string,
          validations: '',
          required: true,
          disabled: false,
          display: true,
        },
      },
      {
        key: 'autoEmailPartInvoice',
        type: 'v-alynk-switch',
        required: false,
        templateOptions: {
          label:'Auto Email Parts Invoices',
          validations: '',
          required: false,
          disabled: false,
          display: true,
        },
      },
    ];
  }

  public async getCustomerDetails(): Promise<void> {
    try {
      this.formlyShowSkeleton(this.customerFields);
      this.flags.loading = true;
      const response = await customerService.getInfoAsync(
        this.constants.customerNumber
      );
      this.flags.loading = false;
      this.updateCustomer = response;
      if (
        this.updateCustomer.birthDate === 'Invalid date' ||
        this.updateCustomer.birthDate === '0' ||
        this.updateCustomer.birthDate == null
      ) {
        this.updateCustomer.birthDate = null;
      } else {
        this.updateCustomer.birthDate = this.$moment(
          this.updateCustomer.birthDate
        ).format(
          this.$parent.$t('customerDetails.updateCustomerBirthDate') as string
        );
      }
      if (this.updateCustomer.phoneNumber.length === 12) {
        this.updateCustomer.phonePrefix = this.updateCustomer.phoneNumber.substring(
          1,
          2
        );
        this.updateCustomer.phoneNumber = this.updateCustomer.phoneNumber.substring(
          2
        );
      } else {
        this.updateCustomer.phonePrefix = '1';
      }
      if (this.updateCustomer.businessPhone.length === 12) {
        this.updateCustomer.businessPhonePrefix = this.updateCustomer.businessPhone.substring(
          1,
          2
        );
        this.updateCustomer.businessPhone = this.updateCustomer.businessPhone.substring(
          2
        );
      } else {
        this.updateCustomer.businessPhonePrefix = '1';
      }
      if (this.updateCustomer.otherPhone.length === 12) {
        this.updateCustomer.otherPhonePrefix = this.updateCustomer.otherPhone.substring(
          1,
          2
        );
        this.updateCustomer.otherPhone = this.updateCustomer.otherPhone.substring(
          2
        );
      } else {
        this.updateCustomer.otherPhonePrefix = '1';
      }
      if (this.updateCustomer.cellPhone.length === 12) {
        this.updateCustomer.cellPhonePrefix = this.updateCustomer.cellPhone.substring(
          1,
          2
        );
        this.updateCustomer.cellPhone = this.updateCustomer.cellPhone.substring(
          2
        );
      } else {
        this.updateCustomer.cellPhonePrefix = '1';
      }
    } finally {
      this.formlyHideSkeleton(this.customerFields);
    }
  }

  public async addOrUpdate(): Promise<void> {
    try {
      this.isCustomerUpdateLoading = true;
      if (
        this.updateCustomer.birthDate === 'Invalid date' ||
        this.updateCustomer.birthDate === '0' ||
        this.updateCustomer.birthDate == null
      ) {
        this.updateCustomer.birthDate = null;
      } else {
        this.updateCustomer.birthDate = this.$moment(
          this.updateCustomer.birthDate
        ).format('YYYYMMDD');
      }

      const response = await customerService.updateCustomerAllFieldsAsync(
        this.updateCustomer
      );
      this.showAlert(
        true,
        this.$t('customerDetails.alertCustomerDetailsUpdatedSuccessfully')
      );
      this.backToList();
    } finally {
      this.isCustomerUpdateLoading = false;
    }
  }
  public backToList(): void {
    this.$router.push({
      name: 'app.repairorders.closed',
      params: {
        tenantId: this.constants.tenantId,
        enterpriseId: this.constants.enterpriseId,
        storeId: this.constants.storeId,
      },
      query: {
        searchParameter: this.constants.searchParameter.toString().trim(),
        searchString: this.constants.searchString,
        lastName: this.constants.lastName,
        firstName: this.constants.firstName,
        customerNumber: this.constants.customerNumber,
        email: this.constants.email,
        phone: this.constants.phone,
      },
    });
  }
}
